import { csrfFetch } from "./csrf_fetch"

// Fire-and-forget usage beacon for client-only features (see
// UsageEventsController, which whitelists the names it accepts).
export function trackUsage(name) {
  csrfFetch("/usage_events", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({name}),
  }).catch(() => {})
}
